import { computed, ref } from 'vue';
import { MainFlowRouteNames, RemainingRouteNames } from '@/types/i-router';
import { LoadingStates } from '@/types/i-loading';
import store from '@/store';

export default class MainContentCode {
	public transitionName = ref('fade');

	private get mainFlowRouteNames(): string[] {
		return Object.values(MainFlowRouteNames);
	}

	public layoutElementStyling = computed((): string => {
		return `visibility: ${this.shouldPageLayoutElementsBeShown.value ? 'visible' : 'hidden'}`;
	});

	public routeIsListing = computed((): boolean => {
		const listingRoutes: string[] = [
			RemainingRouteNames.ORGANISATION_LISTING_OVERVIEW,
			RemainingRouteNames.STUDY_LISTING_OVERVIEW
		];
		return listingRoutes.includes(this.currentRoute.value);
	});

	public currentRoute = computed((): string => {
		const router = store.getters.router();
		return router.current;
	});

	public loadingInProgress = computed((): boolean => {
		const loading = store.getters.loading();
		return loading.state !== LoadingStates.INACTIVE;
	});

	private shouldPageLayoutElementsBeShown = computed((): boolean => {
		return (
			this.mainFlowRouteNames.includes(this.currentRoute.value) ||
			this.currentRoute.value === (RemainingRouteNames.EXISTING_PRESET_BASED_SELECTION as string)
		);
	});
}
